import IckonicLiveAd from '../../Assets/Images/IckonicAds/320x250/ickonic-live-ad.png';
import RealityTrilogy from '../../Assets/Images/IckonicAds/320x250/Reality Trilogy [320x250].jpg';
import IckonicSub from '../../Assets/Images/IckonicAds/320x250/Ickonic [320x250].jpg';
import {RoutePaths} from "../../Constants/RoutePaths";

const IckonicAds320x250 = [
    // {
    //     Image: IckonicLiveAd,
    //     Link: 'https://openvisioneventslimited.telltix.com/events/openvisioneventslimited',
    //     Target: '_blank',
    //     Priority: 1,
    //     LoggedOutOnly: false
    // },
    {
        Image: RealityTrilogy,
        Link: 'https://shop.ickonic.com/product/the-reality-trilogy-special-bundle-incredible-price',
        Target: '_blank',
        Priority: 2,
        LoggedOutOnly: false
    },
    {
        Image: IckonicSub,
        Link: RoutePaths.SignUp[0] + '?plan=Truth-Seeker',
        Target: '_self',
        Priority: 0,
        LoggedOutOnly: true
    }
]

export default IckonicAds320x250;
